import { useState, useCallback } from 'react'

// Simples obfuscação XOR — NÃO é criptografia forte, mas melhor que plaintext
function xorEncrypt(text: string, key: string): string {
  let result = ''
  for (let i = 0; i < text.length; i++) {
    result += String.fromCharCode(text.charCodeAt(i) ^ key.charCodeAt(i % key.length))
  }
  return btoa(result)
}

function xorDecrypt(encoded: string, key: string): string {
  try {
    const text = atob(encoded)
    let result = ''
    for (let i = 0; i < text.length; i++) {
      result += String.fromCharCode(text.charCodeAt(i) ^ key.charCodeAt(i % key.length))
    }
    return result
  } catch {
    return ''
  }
}

function getKey(): string {
  // Usar uma combinação do userAgent + hostname como chave
  const base = navigator.userAgent + (window.location.hostname || 'localhost')
  let hash = 0
  for (let i = 0; i < base.length; i++) {
    const char = base.charCodeAt(i)
    hash = ((hash << 5) - hash) + char
    hash = hash & hash
  }
  return Math.abs(hash).toString(36).padStart(10, '0')
}

export function useSecureStorage(key: string) {
  const storageKey = `crm_secure_${key}`
  const encryptKey = getKey()

  const [value, setValueState] = useState<string>(() => {
    try {
      const stored = sessionStorage.getItem(storageKey)
      if (stored) {
        return xorDecrypt(stored, encryptKey)
      }
    } catch {
      // ignore
    }
    return ''
  })

  const setValue = useCallback(
    (newValue: string) => {
      try {
        if (newValue) {
          sessionStorage.setItem(storageKey, xorEncrypt(newValue, encryptKey))
        } else {
          sessionStorage.removeItem(storageKey)
        }
        setValueState(newValue)
      } catch {
        // Fallback: não armazenar se falhar
        setValueState(newValue)
      }
    },
    [storageKey, encryptKey]
  )

  const clear = useCallback(() => {
    try {
      sessionStorage.removeItem(storageKey)
    } catch {
      // ignore
    }
    setValueState('')
  }, [storageKey])

  return { value, setValue, clear }
}
